import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-styled-header-box',
  templateUrl: './styled-header-box.component.html',
  styleUrls: ['./styled-header-box.component.scss'],
})

export class StyledHeaderBoxComponent {
  @Input() text: string = '';
  @Input() withBackground = false;

}
